import React from 'react';

const Footer = () => {
    return (
        <footer className='py-8 bg-[#000]'>
            <p className='text-center text-white text-sm'>© Copyright <strong>TRANSACTGRAPH SDN BHD</strong>. All Rights Reserved</p>
        </footer>
    );
};

export default Footer;